import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

/**
 * Only sizing. The walk card's chrome and its contents now travel with `MapLibreWalkingRoute` — the shared
 * host styles the popup, the tooltip component styles itself — so this screen no longer carries a copy.
 */
export const StyledPassengerAddress = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "passenger-address-map",
})<{ $hiddenState?: boolean }>`
  width: 100%;
  height: 400px;
`;
